module.exports = __webpack_public_path__ + "static/media/filled_start.50f247cd.svg";